---
title: "Какой PDF-конвертер выбрать для Excel, текста и картинок"
description: "PDF-конвертеры делают разные вещи: Excel в PDF, PDF в JPG, PDF в текст, сжатие и поворот. Вот как не открыть лишний инструмент."
locale: "ru"
date: "2026-06-16"
tags: ["pdf", "конвертер", "инструменты"]
relatedTools: ["excelVPdf", "vJpg", "szhat", "povernut"]
translations:
  en: "which-pdf-converter-to-use"
faq:
  - q: "Есть один универсальный PDF-конвертер?"
    a: "Есть страницы-каталоги, но внутри всё равно разные операции. Excel в PDF, PDF в JPG, PDF в текст и сжатие PDF дают разный результат и имеют разные ограничения."
  - q: "Что можно обработать локально?"
    a: "У pdfy всё: поворот, сжатие, PDF в JPG, PDF в текст, Excel в PDF и работа со страницами выполняются в браузере. Файл не уходит на сервер."
  - q: "А как быть с Word и PowerPoint?"
    a: "Для них нужен полноценный офисный движок, поэтому pdfy их не конвертирует. Сохраните файл как PDF в самом Word или PowerPoint, а затем сожмите или отредактируйте его здесь."
  - q: "С чего начать, если я не понимаю формат?"
    a: "Откройте страницу PDF-конвертера и выберите по исходному файлу: PDF, Excel, HTML или картинка. Если цель простая, конкретный инструмент быстрее универсальной формы."
---

`document_final.pdf` надо "переделать". Во что именно - пока непонятно.
Бухгалтерия просит текст, менеджер хочет картинки для карточки товара,
сайт требует файл меньше 5 МБ. Все эти задачи люди называют одинаково:
нужен PDF-конвертер. На деле это разные операции и разные риски.

Если нужен вход в каталог, он здесь: [PDF-конвертер](/pdf-konverter).
Дальше лучше выбирать не по красивой большой кнопке, а по тому, что
лежит в исходнике и что должно получиться на выходе.

## PDF в текст

[PDF в текст](/pdf-v-text) нужен, когда надо скопировать содержимое и
править его в другом месте. Работает с PDF, где есть текстовый слой:
договор, инструкция, КП, отчёт из Word. Форматирование не сохраняется,
зато текст можно сразу вставить в редактор.

Хороший признак - в просмотрщике PDF можно выделить строку мышкой. Если
выделяется только вся страница как картинка, это скан: текстового слоя
в нём нет, и инструмент честно об этом скажет.

## Excel и HTML в PDF

[Excel в PDF](/excel-v-pdf) и [HTML в PDF](/html-v-pdf) решают другую
задачу: зафиксировать данные, чтобы они одинаково открылись у получателя.
Таблица собирается прямо в браузере: значения ячеек переносятся, а цвета
и объединённые ячейки нет. Если важен точный вид, сохраните PDF в самом
Excel.

С Word и PowerPoint проще всего так же: `Файл → Сохранить как → PDF` в
редакторе. Браузеру тяжело честно пересчитать шрифты, переносы,
колонтитулы и размеры слайдов, поэтому pdfy такие файлы не конвертирует.

## PDF в JPG

[PDF в JPG](/v-jpg) - совсем другая история. Здесь PDF не надо понимать
как офисный документ. Его надо отрисовать как страницы и сохранить
картинки. Это отлично ложится на браузер: pdf.js читает страницы, canvas
рисует, JPG скачивается локально.

Такой вариант хорош для превью, чата, карточки товара, инструкции с
одной страницей. Для архива, договора и документа с кликабельными
ссылками JPG хуже PDF. После конвертации текст уже не выделяется, это
просто пиксели.

## Сжатие и поворот

[Повернуть PDF](/povernut) - самая лёгкая операция. Часто меняется одно
поле `/Rotate`, файл даже не надо пересобирать. Поэтому поворот работает
локально и быстро.

[Сжать PDF](/szhat) сложнее. Браузер пережимает изображения внутри файла,
и для обычных сканов этого часто хватает. Текст и векторная графика
почти не уменьшаются: если файл состоит из них, инструмент так и скажет.

## Как я бы выбирал

Если нужен текст - PDF в текст. Если надо отправить таблицу без
сюрпризов - Excel в PDF. Если нужна картинка - PDF в JPG. Если файл не
принимает форма - сжать. Если скан боком - повернуть.

Универсальный PDF-конвертер полезен как карта. Работать всё равно лучше
конкретным инструментом, который честно говорит, какие ограничения у
операции.
